import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressDistrictSlice = createSlice({
    name: "getAddressDistrict",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressDistrictSlice_actions = getAddressDistrictSlice.actions;
export var fetchData = _getAddressDistrictSlice_actions.fetchData, fetchDataSuccess = _getAddressDistrictSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressDistrictSlice_actions.fetchDataFailure, resetState = _getAddressDistrictSlice_actions.resetState;
export default getAddressDistrictSlice.reducer;
